import { render } from "./TheUser.vue?vue&type=template&id=25a71834"
import script from "./TheUser.vue?vue&type=script&lang=js"
export * from "./TheUser.vue?vue&type=script&lang=js"

import "./TheUser.vue?vue&type=style&index=0&id=25a71834&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__